<template>
  <div
    class="landing-page"
    :class="$route.path === '/mobile-kasim-kampanyalari' && 'mobile-landing'"
    :style="`background:url(${$root.cdnPath}/images/eg-bg-1.png) no-repeat;
        background-position: top center;
        background-repeat: no-repeat;
        height: 100%;
        background-size: cover;`"
  >
    <div class="landing-page-bg" />
    <div class="landing-page-banner">
      <div class="landing-page-head">
        <div class="cta-wrapper">
          <a
            v-for="(button,index) in buttonDesc"
            @click="sendGtmData(button.gtmAction)"
            :key="'cta-action' + index"
            target="_blank"
            :href="button.link"
          >
            {{ button.title }}
          </a>
        </div>
      </div>
      <div class="landing-page-image">
        <h1>
          Yılın En Büyük Kampanyaları İçin İhtiyacınız Olan Her Şey Bu Sayfada!
        </h1>
        <img
          :src="`${$root.cdnPath}/images/eg-logo.png`"
          alt="super indirim gunleri"
        >
      </div>
    </div>
    <div class="landing-page-boxes">
      <h3 class="box-title">
        Promosyon Araçları ile Siz de Yılın En Büyük Kampanyalarında Yerinizi Alın!
      </h3>
      <div class="info-box-wrapper">
        <div
          class="info-box"
          v-for="(box,index) in campaignBoxes"
          :key="index"
        >
          <div
            class="info-box-cta"
            @click="openLink(box.link,box.gtmAction)"
          >
            <div class="desc-w-icon">
              <div
                class="icon"
                :style="`background-color:${box.iconBg}`"
              >
                <Icon :name="box.icon" />
              </div>
              <div class="desc-box">
                <div class="title">
                  {{ box.title }} <Icon name="chevron" />
                </div>
                <div class="desc">
                  {{ box.desc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-boxes cta-box">
      <div
        :key="index"
        v-for="(boxBlock,index) in campaignCtaBoxes"
      >
        <h3 class="box-title">
          {{ boxBlock.title }}
        </h3>
        <div class="info-box-wrapper">
          <div
            class="info-box-cta"
            v-for="(box,boxIndex) in boxBlock.boxes"
            :key="boxIndex"
          >
            <div class="desc-w-icon">
              <div
                class="icon"
              >
                <Icon :name="box.icon" />
              </div>
              <div class="desc-box">
                <div class="title">
                  {{ box.title }}
                </div>
                <div class="desc">
                  {{ box.desc }}
                </div>
              </div>
            </div>
            <div
              class="link"
              @click="openLink(box.link,box.title)"
            >
              {{ box.buttonText }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="third-section">
      <div class="badge-image">
        <img
          :src="`${$root.cdnPath}/images/eg-badge.png`"
          alt=""
        >
      </div>
      <div class="card-wrapper">
        <div
          :key="index"
          class="section-card"
          v-for="(card,index) in campaignThird"
        >
          <img
            :src="`${$root.cdnPath}/images/${card.image}.png`"
            alt=""
          >
          <div class="info">
            <div class="title">
              {{ card.title }}
            </div>
            <div class="desc">
              {{ card.desc }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="slider-section"
    >
      <div class="title">
        Satıcılarımızın Süper İndirim Günleri Yorumları
      </div>
      <swiper
        class="swiper"
        :options="swiperOption"
      >
        <swiper-slide
          v-for="(comment,index) in comments"
          :key="index"
        >
          <div
            class="slider-item"
            :key="index"
          >
            <div class="top">
              <img
                :src="`https://cdn.dsmcdn.com/seller-store/uploads/${comment.image}/logo.jpeg`"
                alt=""
              >
              <div class="customer">
                <div class="customer-name">
                  {{ comment.title }}
                </div>
              </div>
            </div>
            <div class="comment">
              {{ comment.desc }}
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="footer">
      ©2022, DSM Grup Danışmanlık İletişim ve Satış Tic. A.Ş. Her hakkı saklıdır.
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
// eslint-disable-next-line import/extensions
import Icon from '@/components/Icon';
import { openLinkEvent } from '@seller/gilgamesh-web-utils';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default Vue.extend({
  name: 'MobileCampaignLandingPage',
  components: {
    Icon,
    Swiper,
    SwiperSlide,
  },
  created() {
    const downloadBar = document.querySelector('.download-app-bar');
    if (downloadBar) {
      downloadBar.style = 'display:none';
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1.5,
        spaceBetween: 24,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      buttonDesc: [
        {
          title: 'Operasyon İpuçları',
          link: 'https://partner.trendyol.com/account/sso/lms?env=prod&domain=MP&url=/ContentRedirect/463',
          gtmAction: 'Operasyon İpuçları',
        },
      ],
      campaignBoxes: [
        {
          title: 'Kampanyalar',
          icon: 'campaign',
          iconBg: '#FEF2E8',
          desc: 'Kasım kampanyalarına katılanlar satışlarını 5 kata kadar   artırıyor!',
          link: 'tysc://Campaign/available/All',
          buttonText: 'Detaylı Bilgi',
          gtmAction: 'Kampanya',
        },
        {
          title: 'Tekliflerim',
          icon: 'offer',
          iconBg: '#FFEEEC',
          desc: 'Ürünlerinize özel komisyon indirimli ve 3 saatte 1 tekliflerle satışınızı katlayın!',
          link: 'tysc://ProductHunt/Available',
          buttonText: 'Kampanyaya Katıl',
          gtmAction: 'Tekliflerim',
        },
        {
          title: 'İndirim Oluştur',
          icon: 'discount',
          iconBg: '#F4EDFF',
          desc: 'Size uygun kriterleri dilediğiniz gibi belirleyerek kendi kampanyanızı oluşturun!',
          link: 'tysc://FlexiCombo/Create',
          buttonText: 'Tekliflerini Gör',
          gtmAction: 'İndirim Oluştur',
        },
        {
          title: 'Kupon Oluştur',
          icon: 'coupon',
          iconBg: '#E7F9EF',
          desc: 'Kupon oluşturarak müşterilerinizin sepet tutarlarını %20 oranında artırabilirsiniz!',
          link: 'tysc://Coupon/Create',
          buttonText: 'Etiket Fiyatlarını Gör',
          gtmAction: 'Kupon Oluştur',
        },
      ],
      campaignCtaBoxes: [
        {
          title: 'Görünürlüğünüzü Artırarak Ürünlerinizi Daha Fazla Müşteriye Ulaştırın!',
          boxes: [
            {
              title: 'Reklam Yönetimi',
              desc: 'Reklam verip mağazanızın ziyaretçilerle dolmasını sağlayın!',
              link: 'tysc://SellerAds/1',
              buttonText: 'Hemen Reklam Ver',
              icon: 'ads',
            },
            {
              title: 'Otomatik Fiyatlandırma',
              desc: 'Buybox kazanabilmeniz için her şey tek sayfada toplandı!',
              link: 'https://partner.trendyol.com/auto-pricing/landing',
              buttonText: 'Otomatik Fiyatlandırma Tanımla',
              icon: 'pricing',
            },
            {
              title: 'Mağaza Yönetimi',
              desc: 'Mağaza tasarımınızı kasıma özel hazırlayın, müşterilerin satın olma oranını %10 \'a kadar artırın!',
              link: 'tysc://StoreManagement',
              buttonText: 'Mağazayı Güncelle',
              icon: 'store',
            },
            {
              title: 'Hızlı Teslimat',
              desc: 'Müşterilerimizin %84\'ü Hızlı Teslimat etiketli ürünleri tercih ediyor.',
              link: 'https://partner.trendyol.com/fast-delivery',
              buttonText: 'Hızlı Teslimat\'ı İncele',
              icon: 'truck',
            },
          ],
        },
        {
          title: 'Performansınızı Anlık Olarak Takip Edin ve İyileştirme Aksiyonları Alın!',
          boxes: [
            {
              title: 'Canlı Performansım',
              desc: 'Kampanya performansınızı anlık takip edin, aksiyonlarınızı hemen alın!',
              link: 'tysc://Reports/LiveMonitor',
              buttonText: 'Canlı Performansıma Git',
              icon: 'monitor',
            },
            {
              title: 'Favorilenen Ürünler',
              desc: 'Favorilenen ürünleriniz için en uygun kampanyayı oluşturun!',
              link: 'tysc://Reports/VisitFav',
              buttonText: 'Hemen İncele',
              icon: 'hearth',
            },
            {
              title: 'Hedeflerim',
              desc: 'Size özel atanan hedeflerle Kasım\'da işinizi büyütün!\n',
              link: 'https://partner.trendyol.com/growth-center/challenges/approved',
              buttonText: 'Hedeflerime Git',
              icon: 'growth',
            },
            {
              title: 'Sepette Bekleyen Ürünler',
              desc: 'Sepette bekleyen ürünlerinize indirim oluşturun ve satışlarınızı hızlandırın!',
              link: 'https://partner.trendyol.com/business-advisor/diagnoses/sepette-bekleyen-urunler',
              buttonText: 'Hemen İncele',
              icon: 'market',
            },
          ],
        },
      ],
      campaignThird: [
        {
          title: 'Kasım Kampanyalarında İhtiyacınız Olan Her Şey Tek Bir Sayfada!',
          desc: 'Tüm bu önerilerimiz harika bir Kasım dönemi geçirmeniz için hazırlandı. Siz de herkesin beklediği Kasım kampanyalarına en güçlü şekilde hazırlanarak satışlarınızı katlayın!',
          image: 'category',
        },
        {
          title: 'Kampanyada Yer Almak İçin Promosyon Araçlarını Kullanın!',
          desc: 'Kupondan indirim oluşturmaya, flaş tekliflerden kampanyalara bir çok promosyon aracıyla dilediğiniz promosyon ekranıyla satışlarınızı katlayabilirsiniz!',
          image: 'ticket',
        },
        {
          title: 'Görünürlüğünüzü Artırarak Müşterilerinizin Dikkatini Çekin!',
          desc: 'Reklam vererek görünürlüğünüzü artırabilir, hızlı teslimat etiketiyle müşterilerimizin %84\'ünü alışveriş yapmaya motive edebilir ve mağaza tasarımınızı yenileyerek Trendyol\'daki sayfanızı sürekli ilgi çekici kılabilirsiniz!',
          image: 'ads',
        },
        {
          title: 'Anlık Aksiyonlar Alarak Kampanya Performansınızı Artırın!',
          desc: 'Kampanya döneminde hızlı aksiyonlar almak için Canlı Performansım olmazsa olmaz! Performansınızı takip ederken hedeflerinizi de tamamlayıp güzel bir kampanya dönemi geçirin!',
          image: 'report',
        },
      ],
      comments: [
        {
          title: 'TeknoReyonum ',
          desc: 'Kasım kampanyaları işimize çok olumlu yansıyor ve siparişlerimizde 10 kata kadar bir iş artışı oluyor. Bütün yıl kasım ayını bekliyoruz! Teşekkürler.',
          image: '119205',
        },
        {
          title: 'FARMAKOZMETİKA',
          desc: 'Merhabalar, yoğun, bol satışlı ve keyifli geçen bir kampanya dönemi bizim için!',
          image: '214643',
        },
        {
          title: 'Smyrna Wear',
          desc: 'Tüm yıl Kasım ayını bekliyor ve Kasım kampanyalarını düşünerek stok kontrolü yapıyoruz. Tüm yılın en yüksek cirosunu hedefliyoruz. Teşekkürler Trendyol!',
          image: '183683',
        },
      ],
    };
  },
  mounted() {
    window.dataLayer.push({
      event: 'content-view',
      'content-name': this.$route.fullPath,
      'content-view-name': this.$route.name,
    });
  },
  methods: {
    openLink(link, action) {
      window.dataLayer.push({
        event: 'GAEvent',
        eventCategory: 'Kasım Page 2022',
        eventAction: action,
        // eventLabel: window.user.supplierId,
      });

      openLinkEvent(link);
    },
  },
});
</script>

<style lang="scss" scoped>
.landing-page {
  width: 100%;
  height: 100%;
  margin-top: -30px;
  padding: 32px 0 0 0;
  box-sizing: border-box;
  background-color: #F1F2F7;

  &.mobile-landing{
    margin-top: -50px;
    .landing-page-bg{
      img{
        top: 0;
      }
    }
  }

  &-banner {
    z-index: 1;
    display: flex;
    padding: 0 16px;
    justify-content: space-between;

    @media only screen and (max-width: 960px){
      flex-direction: column-reverse;
    }
  }

  &-bg{
    width: 100%;
    img{
      left: 0;
      right: 0;
      top: 90px;
      z-index: 0;
      width: 100%;
      height: auto;
      margin: 0 auto;
      position: absolute;

      @media only screen and (max-width: 960px){
        height: 550px;
      }
    }
  }

  &-head {
    z-index: 1;
    width: 100%;
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: flex-start;

    .cta-wrapper{
      display: flex;
      margin-top: 32px;
      a{
        color: #273142;
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        border-radius: 6px;
        padding: 12px 20px;
        text-decoration: none;
        box-sizing: border-box;
        background-color: #FFFFFF;
      }
      @media only screen and (max-width: 960px){
        width: 100%;
        margin-left: 0;
        flex-direction: column;
        a{
          width: 100%;
          text-align: center;
        }
      }
    }
  }

  &-image {
    z-index: 1;
    display: flex;
    flex: 1 1 auto;
    position: relative;
    align-items: center;

    img {
      right: 0;
      width: 40%;
      height: auto;
      margin-top: 30px;
      position: relative;
    }

    h1 {
      color: #ffffff;
      font-size: 20px;
      font-weight: 500;
    }
  }

  &-boxes {
    z-index: 1;
    display: flex;
    margin-top: 32px;
    padding: 32px 16px;
    position: relative;
    flex-direction: column;
    background-color: #F1F2F7;
    justify-content: space-between;

    .box-title{
      color: #273142;
      font-size: 16px;
      font-weight: 500;
    }

    .info-box {
      width: 100%;
      padding: 16px;
      display: flex;
      margin-top: 20px;
      border-radius: 6px;
      box-sizing: border-box;
      background-color: #fff;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;

      &-wrapper{
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info-box-cta{
          width: 100%;
          display: flex;
          flex-direction: column;

          .desc-w-icon{
            display: flex;
            .icon{
              padding: 16px;
              border-radius: 4px;
            }
            .desc-box{
              display: flex;
              margin-left: 16px;
              flex-direction: column;
              .title{
                color: #273142;
                font-size: 14px;
                font-weight: 500;
                margin-right: 8px;
              }
              .desc{
                color: #6E7787;
                font-size: 12px;
                margin-top: 8px;
                line-height: 14px;
              }
            }
          }
        }
      }

      img{
        width: 100%;
        margin-top: 16px;
        border-radius: 4px;
      }
      h3 {
        color: #273142;
        font-size: 16px;
        font-weight: 500;
        margin: 10px 0 0 0;
      }

      p {
        color: #6E7787;
        margin: 10px 0;
      }

      a {
        text-decoration: none;
      }
    }

    &.cta-box{
      margin-top: 0;
      padding-top: 16px;
      background-color: transparent;

      .box-title{
        color: #fff;
        margin-top: 16px;
      }

      div:last-child{
        h3{
          margin-top: 24px;
        }
      }

      .info-box-cta{
        padding: 16px;
        margin-top: 16px;
        border-radius: 6px;
        background-color: #FFFFFF;

        .desc-w-icon{
          align-items: flex-start;
          .desc-box{
            .desc{
              color: #273142;
            }
          }
          .icon{
            padding: 12px;
            border-radius: 4px;
            background-color: #F7F7FA;
          }
        }

        .link {
          width: 100%;
          color: #FFFFFF;
          padding: 8px 0;
          font-size: 14px;
          font-weight: 500;
          margin-top: 16px;
          line-height: 16px;
          text-align: center;
          border-radius: 4px;
          text-decoration: none;
          background-color: #F27A1A;
        }
      }
    }
  }

  .third-section{
    padding: 32px 16px;
    background: #F1F2F7;

    .badge-image{
      display: flex;
      justify-content: center;
      img{
        width: 90%;
        text-align: center;
        margin-bottom: 36px;
      }
    }

    .card-wrapper{
      display: flex;
      flex-direction: column;
      justify-content: center;
      .section-card{
        width: 100%;
        margin-top: 24px;
        text-align: center;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .info{
          display: flex;
          flex-direction: column;
          .title{
            color: #273142;
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
          }
          .desc{
            font-size: 14px;
            margin-top: 16px;
            line-height: 20px;
          }
        }
        &:first-child{
          margin-top: 0;
        }
      }
    }
  }

  .slider-section {
    padding: 32px 0px 32px 20px;
    position: relative;

    .title{
      display: flex;
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
      align-items: center;
      margin-bottom: 28px;
      justify-content: space-between;
    }

    .slider-item{
      display: flex;
      padding: 16px;
      height: 180px;
      border-radius: 6px;
      flex-direction: column;
      background-color: #FFFFFF;
      .top{
        display: flex;
        align-items: center;
        img{
          width: 40px;
          height: auto;
          border-radius: 20px;
        }
        .customer{
          display: flex;
          padding-left: 8px;
          flex-direction: column;
          &-name{
            color: #273142;
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
          }
          &-title{
            color: #95A1B5;
            font-size: 12px;
            line-height: 14px;
          }
        }
      }
      .comment{
        color: #273142;
        font-size: 14px;
        margin-top: 8px;
        line-height: 16px;
      }
    }
  }
  .footer{
    color: #95A1B5;
    font-size: 14px;
    line-height: 16px;
    padding: 20px 24px;
    background-color: #FFFFFF ;
  }
}
</style>
